import React from 'react';

export default function AppointmentFormNotifications({
  paymentSuccess,
  skippedPaidInfo,
  hasPaymentRestriction,
  paymentActionLoading,
  onDismissSkippedInfo,
}) {
  return (
    <>
      {paymentSuccess && (
        <div className="mb-4 p-3 bg-blue-100 border border-blue-400 text-blue-700 rounded">
          {paymentSuccess}
        </div>
      )}

      {skippedPaidInfo && (
        <div className="mb-4 p-4 bg-yellow-50 border border-yellow-300 rounded-lg">
          <div className="flex items-start space-x-3">
            <svg className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <div className="flex-1">
              <p className="font-medium text-yellow-800 mb-1">
                {skippedPaidInfo.count} {skippedPaidInfo.count === 1 ? 'תור' : 'תורים'} {skippedPaidInfo.type === 'delete' ? 'לא נמחקו' : 'לא עודכנו'}
              </p>
              <p className="text-sm text-yellow-700 mb-2">
                {skippedPaidInfo.type === 'delete'
                  ? 'התורים הבאים לא נמחקו מכיוון שהם כבר שולמו:'
                  : 'התורים הבאים לא עודכנו מכיוון שהם כבר שולמו:'}
              </p>
              <ul className="text-sm text-yellow-700 list-disc list-inside space-y-1">
                {skippedPaidInfo.appointments.map((apt, idx) => (
                  <li key={apt.id || idx}>
                    {new Date(apt.date).toLocaleDateString('he-IL')} בשעה {apt.time}
                    {apt.has_invoice && ' (יש חשבונית)'}
                    {!apt.has_invoice && apt.is_paid && ' (שולם במזומן)'}
                  </li>
                ))}
              </ul>
              <button
                onClick={onDismissSkippedInfo}
                className="mt-3 text-sm font-medium text-yellow-800 hover:text-yellow-900 underline"
              >
                הבנתי, סגור הודעה
              </button>
            </div>
          </div>
        </div>
      )}

      {hasPaymentRestriction && (
        <div className="mb-4 p-3 bg-amber-50 border border-amber-300 text-amber-800 rounded-lg">
          <div className="flex items-start space-x-2">
            {paymentActionLoading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-amber-600 flex-shrink-0 mt-0.5"></div>
            ) : (
              <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            )}
            <div className="flex-1">
              <p className="font-medium text-sm">
                {paymentActionLoading ? 'מעבד בקשת תשלום...' : 'עריכה מוגבלת - התור נעול לשינויים'}
              </p>
              <p className="text-sm mt-1">
                {paymentActionLoading
                  ? 'נא להמתין בזמן יצירת קישור התשלום. לא ניתן לערוך את פרטי התור במהלך תהליך זה.'
                  : 'כאשר יש חשבונית או תשלום שהושלם/ממתין, לא ניתן לערוך את פרטי התור, למחוק אותו או לשנות את הסדרה החוזרת. ניתן לעדכן רק את הסטטוס והערות.'
                }
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
